import { RequestStatus } from 'features/request/requestSlice';
import type { ProjectData, WorkOrderNavData } from 'gql/graphql';
import { ActKc2GroupTypeEnum, SkzsActKc2StatusEnum } from 'gql/graphql';
import { getSkzsActKc2StatusTitle } from 'pages/Project/Common/types';
import { Loader } from 'uikit';
import { capitalize } from 'utils';

import type { Ref } from 'react';
import type React from 'react';
import { Fragment, useImperativeHandle, useMemo } from 'react';
import { Link } from 'react-router-dom';

import { useUerWorkOrderSKzSInfo } from './hooks/useUerWorkOrderSKzSInfo';

import Style from './WorkOrderSkzsPanel.module.css';

interface IWorkOrderSkzsPanel {
    workOrderNavData?: WorkOrderNavData;
    projectData: ProjectData | undefined | null;
    skzsPanelRefreshRef?: Ref<{ uerWorkOrderSKzSInfoRefresh: () => void }>;
}

const skzsStatuses = [SkzsActKc2StatusEnum.New, SkzsActKc2StatusEnum.Updated];

export const WorkOrderSkzsPanel: React.FC<IWorkOrderSkzsPanel> = (props) => {
    const { workOrderNavData, projectData, skzsPanelRefreshRef } = props;

    const { uerWorkOrderSKzSInfoData, uerWorkOrderSKzSInfoStatus, uerWorkOrderSKzSInfoRefresh } =
        useUerWorkOrderSKzSInfo(workOrderNavData?.id);

    useImperativeHandle(skzsPanelRefreshRef, () => ({
        uerWorkOrderSKzSInfoRefresh,
    }));

    const count = useMemo(
        () =>
            skzsStatuses.reduce(
                (acc, s) => {
                    const data =
                        uerWorkOrderSKzSInfoData?.uerWorkOrderSKzSInfo?.data || workOrderNavData?.metadata?.skzs;

                    acc[s] = data?.[`actsKC2SKzS${capitalize(s)}Count`];

                    return acc;
                },
                {} as Record<SkzsActKc2StatusEnum, number | undefined>,
            ),
        [uerWorkOrderSKzSInfoData?.uerWorkOrderSKzSInfo?.data, workOrderNavData?.metadata?.skzs],
    );

    const isPanelHidden = useMemo(() => Object.values(count).every((v) => !v), [count]);

    return !isPanelHidden ? (
        <div className={Style.workOrderSkzsPanel}>
            <div className={Style.workOrderSkzsPanelTitle}>Акты СКзС:</div>
            {uerWorkOrderSKzSInfoStatus === RequestStatus.FETCHING ? (
                <div className={Style.workOrderSkzsPanelLinks}>
                    <Loader size="s" />
                </div>
            ) : (
                <div className={Style.workOrderSkzsPanelLinks}>
                    {skzsStatuses
                        .filter((s) => !!count[s])
                        .map((s, i, items) => (
                            <Fragment key={s}>
                                <Link
                                    className={Style.workOrderSkzsPanelLink}
                                    to={`/projects/uer/${
                                        projectData?.uniqueId ?? ''
                                    }/order/${workOrderNavData?.id}/actsKC2List/${
                                        ActKc2GroupTypeEnum.ByStatusSkzs
                                    }/${s}`}
                                >
                                    {getSkzsActKc2StatusTitle(s, true)} {count[s]}
                                </Link>
                                {i < items.length - 1 && <div className={Style.workOrderSkzsPanelDelim}>,</div>}
                            </Fragment>
                        ))}
                </div>
            )}
        </div>
    ) : (
        <div />
    );
};

WorkOrderSkzsPanel.displayName = 'WorkOrderSkzsPanel';
